import { Col, Row } from "react-grid-system";
import PlaceholderCard from "../components/placeholders/PlaceholderCard";

const Placeholder = () => (
  <Col>
        <Row>
            {
                Array.from({ length: 6 }).map((_, index) => <PlaceholderCard key={index} />)
            }
        </Row>
  </Col>
);

export default Placeholder;